module.exports = __webpack_public_path__ + "img/horizontal_3_4_r_pp12_3.6c8c03c7.png";